import { render, staticRenderFns } from "./NewCombo.vue?vue&type=template&id=1fef49e2&"
import script from "./NewCombo.vue?vue&type=script&lang=js&"
export * from "./NewCombo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports